import React from 'react'

const HoursMessage = ({ message }) => (
  <span className="block mb-4 text-12 font-bold uppercase">({message})</span>
)

export default HoursMessage
